import React from 'react';
import { animateScroll } from 'react-scroll';
import { IntercomAPI } from 'react-intercom';
import { UpArrow } from '../Arrows';
import styles from './styles.scss';

function ProductFooter({ background }) {
  return (
    <div className={styles.container} style={{ background: `url(${background})` }}>
      <div className="container-fluid main-container">
        <div className="col-md-10 col-md-offset-1 col-sm-12">
          <div className="row">
            <div className="col-lg-7 col-md-8 col-sm-9 col-center col-xs-12 mtb150">
              <div className="row">
                <div className="col-sm-6">
                  <a className="btn btn-dc-primary btn-block" onClick={() => IntercomAPI('show')}>
                    START A CUSTOM PROJECT
                  </a>
                </div>
                <div className="col-sm-6">
                  <a onClick={scrollToTop} className={`${styles.choose} btn btn-dc-blue btn-block`}>
                    CHOOSE A PACKAGE <UpArrow />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function scrollToTop() {
  animateScroll.scrollToTop({
    duration: 500,
    delay: 100,
    smooth: true
  });
}

export default ProductFooter;



// WEBPACK FOOTER //
// ./src/components/ProductFooter/index.js